import { render, staticRenderFns } from "./BaseGlobalAlert.vue?vue&type=template&id=612b43de&"
import script from "./BaseGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./BaseGlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports